<template>
    <g id="frame-animators">
        <grid-animator
            v-if="isLanding"
            ref="grid"
            :rootElement="rootElement.querySelector('#grid-lines')"
            v-on:complete="complete"
        />
        <logo-animator
            v-if="isLanding"
            ref="logo"
            :rootElement="rootElement.querySelector('g#smash-delta')"
            v-on:complete="complete"
        />
    </g>
</template>

<script>
import { mapState } from 'vuex'

import GridAnimator from './animators/GridAnimator'
import LogoAnimator from './animators/LogoAnimator'

export default {
    components: {
        GridAnimator,
        LogoAnimator
    },

    props: {
        rootElement: {
            type: SVGSVGElement,
            required: true
        }
    },

    computed: {
        ...mapState(['scene']),

        isLanding() {
            return this.scene === 'landing'
        },

        isIntro() {
            return this.scene === 'intro'
        }
    },

    mounted() {
        setTimeout(() => this.start(), 1000)
    },

    methods: {
        start() {
            try {
                this.$refs.grid.start()
                this.$refs.logo.start()
            } catch (e) {
                // i think its fine
            }
        },

        complete(animator) {
            if (animator === 'logo') {
                this.$store.commit('setScene', 'intro')
            }
        }
    }
}
</script>

<style>
</style>
